//
import type { RouteLocation } from 'vue-router';
import { RouteNames } from '../routeNames';

const rootPathRedirect = (to: RouteLocation) => {
  if ((to.query.code && to.query.state) || to.query.error || to.query.errorCode) {
    return { name: RouteNames.POST_LOGIN };
  } else if (to.query.registrationId) {
    window.location.assign(
      `${window.appConfig.auth.registrationUrl}/?sessionId=0&sessionData=0&platform=0&source=${to.query.source}#/registration/personalized/${to.query.registrationId}`
    );
  }
  return { name: RouteNames.PRE_LOGIN, query: { ...to.query } };
};

export default rootPathRedirect;
